const configs = [
  {
    projectId: 8,
    groupNames: ['投点']
  }
]

function sameProject(projectId, targetProjectId) {
  return String(projectId) === String(targetProjectId)
}

function matchGroupName(group, groupNames) {
  const classifyName = group && group.classifyName ? group.classifyName : ''
  return groupNames.some(name => classifyName.indexOf(name) > -1)
}

function hasPapers(group) {
  return !!(group && Array.isArray(group.paperList) && group.paperList.length)
}

export function getRequiredLocationSignInGroups(projectId, groupList) {
  const config = configs.find(item => sameProject(projectId, item.projectId))
  if (!config || !Array.isArray(groupList)) {
    return []
  }
  return groupList.filter(group => hasPapers(group) && matchGroupName(group, config.groupNames))
}

export function hasLocationSignInConfig(projectId) {
  return configs.some(item => sameProject(projectId, item.projectId))
}

export default configs
